import React from 'react';

export default function ProjectCards({ projects }) {
  return (
    <div className="flex flex-wrap justify-center items-center gap-6 w-full p-4 sm:p-8">
      {projects.map((project) => (
        <div
          key={project.id}
          className="relative w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 transition-transform transform hover:scale-105"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1000"
        >
          <img
            src={project.image}
            alt={project.alt}
            className="w-full h-auto rounded-lg shadow-lg"
          />
          <div className="absolute top-2 right-2 bg-yellow-500 rounded-full p-2 cursor-pointer transition-transform transform hover:scale-110">
            <i className="fas fa-plus text-black"></i>
          </div>
          <div className="mt-4">
            <h2 className="text-lg font-semibold text-gray-800">{project.title}</h2>
            <p className="text-sm text-gray-500">
              {project.category} • {project.type}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
